import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Dictionary } from '../handbooks.types';

export interface CardProps {
    dictionary: Dictionary;
}

const TITLE_LIMIT = 80;

export const Card = ({ dictionary: { imageUrl, link, source, title } }: CardProps) => {
    let displayedTitle = '';

    if (title && title.length > TITLE_LIMIT) {
        const words = title.split(' ');

        while (displayedTitle.length < TITLE_LIMIT) {
            displayedTitle += words.shift() + ' ';
        }
        displayedTitle += '...';
    }

    return (
        <>
            <div
                className="handbooks-card-item"
                style={{
                    backgroundImage: `url(${imageUrl})`,
                }}
                onClick={() => open(link, '_self')}
            >
                <span className="label">
                    <span className="title">{displayedTitle || title}</span>
                    {source === 'uploaded' && (
                        <span className="dl-icon">
                            <DownloadOutlined />
                        </span>
                    )}
                </span>
            </div>
        </>
    );
};
